import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Tenant, TenantData } from '../../../@core/interfaces/masters/tenant';
import { environment } from '../../../../environments/environment';
import { DistrictData } from '../../../@core/interfaces/masters/district';
import { StateData, StateMst } from '../../../@core/interfaces/masters/state';
import { CountryData, CountryMst } from '../../../@core/interfaces/masters/country';
import { INgxSelectOption } from 'ngx-select-ex';
import { getDeepFromObject } from '../../helpers';
import { EMAIL_PATTERN } from '../constants';
import { UserTypeValue, ActionDescription, UserData } from '../../../@core/interfaces/common/users';
import * as timeZone from './../../../data/timeZone_Info.json';
// import * as countryCodeLists from './../../../data/countryCode.json';
import * as customerType from './../../../data/customer-type.json';

import { onBoardNewCustomer, TenantBranchData } from '../../../@core/interfaces/masters/tenantbranch';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { NbAuthService, NB_AUTH_OPTIONS } from '@nebular/auth';
import { OtpVerifyDialogComponent } from '..';
import { NbStepperComponent } from '@nebular/theme';
import { UsertypeData } from '../../../@core/interfaces/masters/usertype';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { SettingService } from '../../../@theme/components/common/service/settings.service';
@Component({
  selector: 'ngx-register-tenant',
  templateUrl: './register-tenant.component.html',
  styleUrls: ['./register-tenant.component.css']
})
export class RegisterTenantComponent implements OnInit {
  tenantAddForm: FormGroup;
  newTenantData: onBoardNewCustomer;
  tenantId: any = 'f630b463-cb88-40c5-acee-7bfedbe87994';
  placeholder: string = "Select";
  @ViewChild('stepper') stepperComponentInstance: NbStepperComponent;
  allowClear: any = true;
  multiple: boolean = false;
  isSubmitted: boolean = false;
  isSecondFormSubmitted: boolean = false;
  isThirdFormSubmitted: boolean = false;
  tenantCreatedClickEventCount: number = 0;
  isAlreadyExists:boolean=false;
  isAlreadyExistsMessage:string;

  stateData: any;
  loadStateData: any;
  countryData: any;
  loadDistrictData: any;
  districtData: any;
  countriesList: CountryMst[];
  public timeZoneList: Array<string>[] = (timeZone as any).default;
  // countryCodeDropDownLists: string[] = (countryCodeLists as any).default;
  subscriptionModeList=[{value:"Trial",display:"Trial"},{value:"Live",display:"Live"}];
  customerSubscriptionType: CustomerTypeOption[] = (customerType as any).default;
  customerTypeDropDownList: CustomerTypeOption[] = this.subscriptionTypeList;
  
  @ViewChild('otpVerify') otpVerifyInstance: OtpVerifyDialogComponent;
  statesList: StateMst[];
  loadstatesList: StateMst[];
  protected readonly unsubscribe$ = new Subject<void>();
  isconfirmation: boolean = false;
  tenantReturnData: Tenant;
  newBranchData: any;
  tenantBranchData: any;
  isOtpDia: boolean = false;
  editTenantData: Tenant;
  updatedTenantResponse: any;
  otpId:any;
  newTenant: string = "newtenant";
  minLength: number = this.getConfigValue('forms.validation.password.minLength');
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  isEmailRequired: boolean = this.getConfigValue('forms.validation.email.required');
  isPasswordRequired: boolean = this.getConfigValue('forms.validation.password.required'); 
  strategy: string = this.getConfigValue('forms.register.strategy');
  errors: string[] = [];
  messages: string[] = [];
  firstForm: FormGroup;
  secondForm: FormGroup;
  thirdForm: FormGroup;
  @Output() diaClose: EventEmitter<any> = new EventEmitter<any>();
  tenantMessageResponse: any;
  isCustomerExist: boolean = false;
  saveButtonDisabled: boolean = false;
  refList:any;
  UserTypeData: any;
  adminUserTypeId: any = [];
  minMobileLength: number;
  private storageProviderId = Number(localStorage.getItem("storageProvider")?.split('#')[1] ?? 1);

  smsdto={"variables":[],"template_id":"","to":"","service":"T"};
  private tenandId = localStorage.getItem("tenantId");
  private countryCode = localStorage.getItem('LoginCountryCode');
 isCreateCountrySuperAdmin: boolean = false;

  constructor(private settingsService: SettingService,protected rolesService: RolesData,protected usertypeService: UsertypeData,protected userService: UserData,protected cd: ChangeDetectorRef,protected service: NbAuthService,@Inject(NB_AUTH_OPTIONS) protected options = {},protected patRegSrvc: PatientRegistrationData, protected tenantBrchSrvc: TenantBranchData, protected tenantSrvc: TenantData, private router: Router, private route: ActivatedRoute, protected stateSrvc: StateData, protected cntrySrvc: CountryData, protected districtSrvc: DistrictData,
    private builder: FormBuilder) {
      const passwordValidators = [
        Validators.minLength(this.minLength),
        Validators.maxLength(this.maxLength),
      ];
      this.isPasswordRequired && passwordValidators.push(Validators.required);
      const emailValidators = [
        Validators.pattern(EMAIL_PATTERN),
      ];
      this.isEmailRequired && emailValidators.push(Validators.required);
      this.firstForm = this.builder.group({
      newtenantName: [null, [Validators.required, Validators.pattern('^[^\\s]+[a-zA-Z\\s]*[^\\s]$')]],
      mobile: [null, [Validators.required, Validators.pattern('^[0-9-]+$')]],
      newAltPh: [null, [Validators.pattern('^[0-9-]+$'), Validators.maxLength(10), Validators.minLength(10)]],
      contactName: [null, [Validators.required, Validators.pattern('^[^\\s]+[a-zA-Z\\s]*[^\\s]$')]],
      newEmail: [null, [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      mobileCountryCode: [this.countryCode, [Validators.required]],
      controlCenterCountryCode: [null, this.isCreateCountrySuperAdmin ? [Validators.required]:[]],
      tenantCountryCode: [null, this.isCreateCountrySuperAdmin ? [Validators.required]:[]],
      });
  
      this.secondForm = this.builder.group({
        area: [null, []],
        streetname: [null, []],
        city: [null, [Validators.required, Validators.pattern('^[A-Za-z0-9]+$')]],
        state: [null, []],
        district: [null, []],
        country: [null, [Validators.required]],
        pincode: [null, [Validators.required, Validators.pattern('^[0-9]+$')]],
        timeZone: ['India Standard Time', [Validators.required]],
        subscriptionType: ['Live', [Validators.required]],
        customerType: [  this.fetchDefaultType(), [Validators.required]],
        noOfBeds: [null, []],
      });
  
      this.thirdForm = this.builder.group({
        noOfLicence: [1, [Validators.required, Validators.min(1)]],
        branchCount: [1, [Validators.required, Validators.min(1)]],
        password: [null, [...passwordValidators]],
        confirmPassword: [null, [...passwordValidators]],
        tenantUserId: new FormControl(null, []),
      });
    
    
    this.tenantAddForm = this.builder.group({

      newtenantName: new FormControl(null, [Validators.required, Validators.pattern('^[^\\s]+[a-zA-Z\\s]*[^\\s]$')]),
      mobile: new FormControl(null, [Validators.required, Validators.pattern('^[0-9-]+$'), Validators.maxLength(10), Validators.minLength(10)]),
      newAltPh: new FormControl(null, [Validators.pattern('^[0-9-]+$'), Validators.maxLength(10), Validators.minLength(10)]),
      contactName: new FormControl(null, [Validators.required, Validators.pattern('^[^\\s]+[a-zA-Z\\s]*[^\\s]$')]),

      newEmail: new FormControl(null, [...emailValidators]),
      area: new FormControl(null, []),
      streetname: new FormControl(null, []),
      city: new FormControl(null, [Validators.required, Validators.pattern('^[A-Za-z0-9]+$')]),
      state: new FormControl(null, []),
      district: new FormControl(null, []),
      country: new FormControl(null, []),
      tenantUserId: new FormControl(null, []),
      password: new FormControl(null, [...passwordValidators]),
      confirmPassword: new FormControl(null, [...passwordValidators]),
      noOfLicence: new FormControl(1, [Validators.required, Validators.min(1)]),
      pincode: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+$'), Validators.maxLength(6), Validators.minLength(6)]),
      noOfBeds: new FormControl(null, []),
    }

    );
          this.firstForm.get('mobileCountryCode')?.valueChanges.subscribe((code) => {
            this.updateMobileNumberValidation(code);
            });
  }

    get subscriptionTypeList(){
      const splitArray = this.deploymentType.split(',').map(item => item.trim().toLowerCase());
      const filtered = this.customerSubscriptionType.filter(item =>
        splitArray.includes(item.deploymentMode.toLowerCase())
      );
      return filtered;
    }
  get password() { return this.thirdForm.get('password'); }
  get confirmPassword() { return this.thirdForm.get('confirmPassword'); }
  ngOnInit(): void {
    this.loadDistrict();
    this.loadState();
    this.loadGeo();
    
  }
  loadDistrict(): void {
      this.districtSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.districtData = data;
          this.loadDistrictData = this.districtData;

        }, (error) => {

        }, () => {

        });

      }
    updateMobileNumberValidation(countryCode: string) {
    const { minLength, maxLength } = this.settingsService.getMinMaxLength(countryCode);
    const { minPinLength, maxPinLength } = this.settingsService.getPinCodeMinMaxLength(countryCode);
    this.firstForm.get('mobile')?.setValidators([ Validators.required, Validators.pattern('^[0-9]+$'),
      Validators.minLength(minLength),
      Validators.maxLength(maxLength)
    ]);
  
        this.secondForm.get('pincode')?.setValidators([Validators.required,Validators.pattern('^[0-9]+$'),
      Validators.minLength(minPinLength),
      Validators.maxLength(maxPinLength)
    ]);
    this.minMobileLength = minLength
    this.firstForm.get('mobile')?.updateValueAndValidity();
    this.secondForm.get('pincode')?.updateValueAndValidity();
    var code = this.countryData?.find(x=>x.countryCode == countryCode)
    this.secondForm.controls["country"].setValue(code?.id);
    this.secondForm.controls["country"].disable();
  }
   
  onClear() {
    this.isOtpDia = true;
  }
  get fval3(): { [key: string]: AbstractControl } { return this.thirdForm.controls; }
  get fval1(): { [key: string]: AbstractControl } { return this.secondForm.controls; }

  get fval(): { [key: string]: AbstractControl } { return this.firstForm.controls; }

   onSetCountry(value){
       if(value == 'country'){

        this.secondForm.get('country').valueChanges.subscribe(x => {
          if (x !== null && x !== undefined && x !== "" ) {
            this.secondForm.get('district').setValue(null);
            this.secondForm.get('state').setValue(null);
             this.loadDistrictData = this.districtData?.filter(z => z.countryId ==x);
            this.loadStateData = this.stateData?.filter(y => y.countryId == x);
          }
          else {
            this.loadstatesList = this.stateData?.slice(0);
          }
        });
      }
    }
  onFirstSubmit() {
    this.isSubmitted =true;
    if(!this.isAlreadyExists){
      this.firstForm.markAsDirty();
    }

  }
  toLowerCase(event: any) {
    event.target.value = event.target.value.toLowerCase();
  }
  
  onSecondSubmit() {
    this.isSecondFormSubmitted =true;
    this.secondForm.markAsDirty();
  }
  fetchDefaultType(){
    const match = this.customerSubscriptionType.find(
      e => e.deploymentMode === this.deploymentType.split(',')[0]
    );
    return match?.value;
  }
  onThirdSubmit() {
    this.isThirdFormSubmitted =true;
  this.thirdForm.markAsDirty();
  }

  onDistrictChge(event: INgxSelectOption[]): void {
    if (event != null && event.length > 0) {
      this.secondForm.controls["country"].setValue(event[0].data.countryId);
      this.secondForm.controls["state"].setValue(event[0].data.stateId);
    }
    else {
      return;
    }
  }
  loadGeo(): void {
    this.cntrySrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.countryData = data.value;
         this.settingsService.setCountryData(data.value);
    }, (error) => {

    }, () => {

    });
  }
    loadState(): void {
      this.stateSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.stateData = data.value;
        this.loadStateData = data.value;
    }, (error) => {

    }, () => {

    });
  }
  validateIsExists(event,type){
    this.firstForm.enable(); 
    if(event!=undefined  && event!=null &&  event.target.value?.length>=this.minMobileLength ){
    if(type==="mobile"){
        this.checkValidationIsExists(event.target.value,null);   
    }else if(type==="email"){
      this.checkValidationIsExists(null,event.target.value);   
    }
  }
  }

  checkValidationIsExists(mobileNumber,emailAddress){
    
    let requestURL="";
    if(mobileNumber != null){   requestURL="users/validateTenantIsExists?mobileNumber="+mobileNumber}
    else if(emailAddress != null){   requestURL="users/validateTenantIsExists?emailAddress="+emailAddress};

    this.usertypeService.list(requestURL).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.isAlreadyExists=data.details.isExists;
      this.isAlreadyExistsMessage=data.details.type;
      if(this.isAlreadyExists){  this.firstForm.disable();
        if(mobileNumber===null){ this.firstForm.controls['newEmail'].enable(); }
        else if(emailAddress===null){ this.firstForm.controls['mobile'].enable(); }}
        else{this.firstForm.enable();}
          
    }, (error) => {

    }, () => {

    });
  }
  fetchUsertype() {
    this.isSubmitted = false;
    this.usertypeService.list(`tenants/${this.tenantReturnData.id}/usertypes`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.UserTypeData = data.value;
      this.adminUserTypeId = this.UserTypeData.find(element => element.name.toLowerCase() == "administrator").id;

    }, (error) => {

    }, () => {

    });
  }
   
  onSave(): void {
    this.isThirdFormSubmitted = true;
    if (this.thirdForm.valid && this.secondForm.valid && this.firstForm.valid && !this.isAlreadyExists) {
      this.tenantCreatedClickEventCount++;
      this.saveButtonDisabled =true;
      if(this.tenantCreatedClickEventCount==1){
        this.newTenantData = {

          name: this.firstForm.get('newtenantName').value,
          area: this.secondForm.get('area').value == null ? this.secondForm.get('city').value : this.secondForm.get('area').value,
          street: this.secondForm.get('streetname').value,
          city: this.secondForm.get('city').value,
          country: this.secondForm.get('country').value,
          state: this.secondForm.get('state').value,
          district: this.secondForm.get('district').value,
          pincode: this.secondForm.get('pincode').value,
          noOfBeds: this.secondForm.get('noOfBeds').value ?? 0,
          mobileCountryCode: this.firstForm.get('mobileCountryCode').value,
          timeZone: this.secondForm.get('timeZone').value,
          createdDate:new Date(),
          contactName: this.firstForm.get('contactName').value,
          phoneNum: this.firstForm.get('mobile').value,
          emailAddr: this.firstForm.get('newEmail').value,
          other_AddPHNO: this.firstForm.get('newAltPh').value,
          noOfLicences: this.thirdForm.get('noOfLicence').value,
          noOfBranch: this.thirdForm.get('branchCount').value,
          password: this.thirdForm.get('password').value,
          confirmPassword: this.thirdForm.get('confirmPassword').value,
          subscriptionType: this.secondForm.get('subscriptionType').value,
          customerType: this.secondForm.get('customerType').value,
          storageProvider:this.storageProviderId,
          controlCenter:this.firstForm.get('controlCenterCountryCode').value,
          superAdminController:this.isCreateCountrySuperAdmin,
          tenantCountryCode: this.firstForm.get('tenantCountryCode').value
        };
        this.tenantBrchSrvc.onBoardNewCustomer(`${this.apiUrl}/tenants/${this.tenandId}/tenantbranch/newTenantCustomerOnboarding`, this.newTenantData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    
          this.tenantReturnData = data.details;
        }, (error) => {
    
          if(error.error.status == 404)
          {
            this.isCustomerExist =true;
            this.saveButtonDisabled =false;
          }
          this.cd.detectChanges()
        }, () => {
          this.isThirdFormSubmitted = false;
          this.isSecondFormSubmitted =false;
          this.isSubmitted =false;
          this.cd.detectChanges()
          this.sendOtp();
         this.isconfirmation = true;
    
          setTimeout(() => {
            this.isconfirmation = false;
          }, 4000);
        });
      }
   
      }
      else
     {
       this.saveButtonDisabled =false;
       return }; 
  }
 

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
  
  
  sendTenantId() {
    this.patRegSrvc.sendMessageOtp1("communication/" + this.editTenantData.id + '/' + this.editTenantData.id + '/sendcustomerid/' + this.updatedTenantResponse.tenantUserId + '/' + this.updatedTenantResponse.phoneNum).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
         this.tenantMessageResponse = data;

    }, (error) => {
    }, () => {
    });
  }
  onCancel()
  {
    this.stepperComponentInstance.reset(); 
    this.firstForm.reset();
    this.secondForm.reset();
    this.thirdForm.reset();
    this.isSubmitted =false;
    this.isThirdFormSubmitted = false;
    this.isSecondFormSubmitted =false;
    this.diaClose.emit(null);
  }

  sendOtp() {
    this.patRegSrvc.sendMessageOtp("communication/" + this.tenantReturnData.id + '/' + this.tenantReturnData.id + '/sendotp/' + this.tenantReturnData.phoneNum,this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.otpId = data;
    }, (error) => {
     

    }, () => {
      this.stepperComponentInstance.next();
      this.isCustomerExist =false;

      this.isOtpDia = true;
      this.otpVerifyInstance.fromTenantRegistration(this.tenantReturnData?.phoneNum,this.tenantReturnData?.id,this.otpId)
      this.cd.detectChanges();

    });

  }

  get apiUrl(): string {
    return environment.apiUrl;
  }
  get deploymentType(): string {
    return environment.deploymentType;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.unsubscribe();
  }
  onOtpDiaClose(data: any): void
  {
    if (data == null)
      {this.isOtpDia = false;
        this.diaClose.emit(null);
      }
    else if (data.otpStatus == "approved" || data.otpStatus == "success") {
     this.router.navigate(['pages/users/tenantlist/newcustomer']);
    }
  } 
}
type CustomerTypeOption = {
  value: string;
  display: string;
  deploymentMode: string;
};